'use client';

import React from 'react';
import { type LayoutProps } from './layout.type';
const LayoutMobile: React.FC<LayoutProps> = ({
  children
}) => {
  return <>{children}</>;
};
export default LayoutMobile;